module.exports = __webpack_public_path__ + "static/media/matilde-cap-china-hello.a0a019cd.png";